import { useState, useRef } from 'react';
import SelectSymbol from '../SelectSymbol';
import { createQuickStrategy } from '../../services/QuickStrategyService';

/**
 * props:
 * - onNotification
 */
function QuickStrategyModal(props) {

      const [symbol, setSymbol] = useState('');
      const [percentage, setPercentage] = useState(10);
      const [targetProfit, setTargetProfit] = useState(2);
      const [rsiPeriod, setRsiPeriod] = useState(14);
      const [rsiBuyLevel, setRsiBuyLevel] = useState(30);
      const [isCreating, setIsCreating] = useState(false);
    const btnClose = useRef(null);

    function onSymbolChange(event) {
        setSymbol(event.target.value);
    }

    function onQuickSymbolSelect(selectedSymbol) {
        setSymbol(selectedSymbol);
        // Atualiza o SelectSymbol programaticamente
        const selectElement = document.getElementById('quickStrategySymbol');
        if (selectElement) {
            selectElement.value = selectedSymbol;
            // Dispara o evento change para garantir que o SelectSymbol seja atualizado
            const event = new Event('change', { bubbles: true });
            selectElement.dispatchEvent(event);
        }
    }

    function onPercentageChange(event) {
        const value = parseFloat(event.target.value);
        if (value >= 1 && value <= 100) {
            setPercentage(value);
        }
    }

    function onTargetProfitChange(event) {
        const value = parseFloat(event.target.value);
        if (value >= 0.1 && value <= 100) {
            setTargetProfit(value);
        }
    }

    function onRsiPeriodChange(event) {
        const value = parseInt(event.target.value);
        if (value >= 5 && value <= 50) {
            setRsiPeriod(value);
        }
    }

    function onRsiBuyLevelChange(event) {
        const value = parseFloat(event.target.value);
        if (value >= 0 && value <= 50) {
            setRsiBuyLevel(value);
        }
    }

    async function onCreateQuickStrategy() {
        if (!symbol) {
            if (props.onNotification)
                props.onNotification({ type: 'error', text: 'Selecione um símbolo!' });
            return;
        }

        if (percentage < 1 || percentage > 100) {
            if (props.onNotification)
                props.onNotification({ type: 'error', text: 'Porcentagem deve estar entre 1% e 100%!' });
            return;
        }

        if (targetProfit < 0.1 || targetProfit > 100) {
            if (props.onNotification)
                props.onNotification({ type: 'error', text: 'Lucro alvo deve estar entre 0.1% e 100%!' });
            return;
        }

        setIsCreating(true);

        try {
            const strategyData = {
                symbol,
                percentage,
                targetProfit,
                rsiPeriod,
                rsiBuyLevel
            };

            await createQuickStrategy(strategyData);

            setIsCreating(false);
            btnClose.current.click();
            
            if (props.onNotification)
                props.onNotification({ 
                    type: 'success', 
                    text: `Estratégia rápida criada com sucesso para ${symbol}! A compra será executada quando RSI <= ${rsiBuyLevel} e venda quando lucro atingir ${targetProfit}%` 
                });

            // Reset form
            setSymbol('');
            setPercentage(10);
            setTargetProfit(2);
            setRsiPeriod(14);
            setRsiBuyLevel(30);
        } catch (err) {
            setIsCreating(false);
            if (props.onNotification)
                props.onNotification({ 
                    type: 'error', 
                    text: err.response ? err.response.data : err.message 
                });
        }
    }

    return (
        <div className="modal fade" id="modalQuickStrategy" tabIndex="-1" aria-labelledby="modalQuickStrategyLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="modalQuickStrategyLabel">
                            <svg className="icon icon-xs me-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
                            </svg>
                            Estratégia Rápida
                        </h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={btnClose}></button>
                    </div>
                      <div className="modal-body">
                          <div className="mb-3">
                              <label htmlFor="quickStrategySymbol" className="form-label">Símbolo</label>
                              <SelectSymbol
                                  id="quickStrategySymbol"
                                  symbol={symbol}
                                  onChange={onSymbolChange}
                                  disabled={isCreating}
                              />
                              <div className="form-text">Escolha o par de moedas para negociar</div>
                              <div className="mt-2 text-center">
                                  <label className="form-label small text-muted">Seleção Rápida:</label>
                                  <div className="btn-group d-flex justify-content-center" role="group">
                                      <button
                                          type="button"
                                          className={`btn btn-sm ${symbol === 'SOLUSDC' ? 'btn-primary' : 'btn-outline-primary'}`}
                                          onClick={() => onQuickSymbolSelect('SOLUSDC')}
                                          disabled={isCreating}
                                      >
                                          SOL/USDC
                                      </button>
                                      <button
                                          type="button"
                                          className={`btn btn-sm ${symbol === 'BTCUSDC' ? 'btn-primary' : 'btn-outline-primary'}`}
                                          onClick={() => onQuickSymbolSelect('BTCUSDC')}
                                          disabled={isCreating}
                                      >
                                          BTC/USDC
                                      </button>
                                      <button
                                          type="button"
                                          className={`btn btn-sm ${symbol === 'BNBUSDC' ? 'btn-primary' : 'btn-outline-primary'}`}
                                          onClick={() => onQuickSymbolSelect('BNBUSDC')}
                                          disabled={isCreating}
                                      >
                                          BNB/USDC
                                      </button>
                                      <button
                                          type="button"
                                          className={`btn btn-sm ${symbol === 'ETHUSDC' ? 'btn-primary' : 'btn-outline-primary'}`}
                                          onClick={() => onQuickSymbolSelect('ETHUSDC')}
                                          disabled={isCreating}
                                      >
                                          ETH/USDC
                                      </button>
                                  </div>
                              </div>
                          </div>

                        <div className="mb-3">
                            <label htmlFor="quickStrategyPercentage" className="form-label">
                                Porcentagem de Trabalho: <strong>{percentage}%</strong>
                            </label>
                            <input 
                                type="range" 
                                className="form-range" 
                                id="quickStrategyPercentage"
                                min="1" 
                                max="100" 
                                value={percentage} 
                                onChange={onPercentageChange}
                                disabled={isCreating}
                            />
                            <div className="form-text">Quanto do seu saldo será usado para esta estratégia (1% a 100%)</div>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="quickStrategyTargetProfit" className="form-label">
                                Lucro Alvo: <strong>{targetProfit}%</strong>
                            </label>
                            <input 
                                type="range" 
                                className="form-range" 
                                id="quickStrategyTargetProfit"
                                min="0.1" 
                                max="20" 
                                step="0.1"
                                value={targetProfit} 
                                onChange={onTargetProfitChange}
                                disabled={isCreating}
                            />
                            <div className="form-text">A venda será executada quando o lucro atingir esta porcentagem (0.1% a 20%)</div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label htmlFor="quickStrategyRsiPeriod" className="form-label">
                                    Período RSI: <strong>{rsiPeriod}</strong>
                                </label>
                                <input 
                                    type="number" 
                                    className="form-control" 
                                    id="quickStrategyRsiPeriod"
                                    min="5" 
                                    max="50" 
                                    value={rsiPeriod} 
                                    onChange={onRsiPeriodChange}
                                    disabled={isCreating}
                                />
                                <div className="form-text">Período para cálculo do RSI (5 a 50)</div>
                            </div>

                            <div className="col-md-6 mb-3">
                                <label htmlFor="quickStrategyRsiBuyLevel" className="form-label">
                                    Nível RSI para Compra: <strong>{rsiBuyLevel}</strong>
                                </label>
                                <input 
                                    type="number" 
                                    className="form-control" 
                                    id="quickStrategyRsiBuyLevel"
                                    min="0" 
                                    max="50" 
                                    step="0.1"
                                    value={rsiBuyLevel} 
                                    onChange={onRsiBuyLevelChange}
                                    disabled={isCreating}
                                />
                                <div className="form-text">Compra será executada quando RSI ≤ {rsiBuyLevel} (0 a 50, recomendado: 30)</div>
                            </div>
                        </div>

                        <div className="alert alert-info">
                            <h6 className="alert-heading">Como funciona:</h6>
                            <ul className="mb-0">
                                <li>O sistema monitora o preço atual do símbolo selecionado</li>
                                <li>A <strong>compra</strong> será executada automaticamente quando o RSI estiver ≤ {rsiBuyLevel} (momento de oversold)</li>
                                <li>Na compra, será usado <strong>{percentage}% do seu saldo disponível</strong> em {symbol || 'USDT'}</li>
                                <li>A <strong>venda</strong> será executada automaticamente quando o lucro atingir <strong>{targetProfit}%</strong></li>
                                <li>Na venda, será vendido <strong>100% da quantidade comprada</strong></li>
                            </ul>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" disabled={isCreating}>
                            Cancelar
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-success" 
                            onClick={onCreateQuickStrategy}
                            disabled={isCreating || !symbol}
                        >
                            {isCreating ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Criando...
                                </>
                            ) : (
                                <>
                                    <svg className="icon icon-xs me-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                    </svg>
                                    Criar Estratégia
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default QuickStrategyModal;

